import {combineReducers} from "redux";
import create from "./create";
import update from "./update";
import del from "./delete";

export default combineReducers({create, update, del});
